"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _react2 = require("../../hooks/react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../../Button"));

var _Gate = _interopRequireDefault(require("../../Gate"));

var _Grid = _interopRequireDefault(require("../../Grid"));

var _Spacing = _interopRequireDefault(require("../../Spacing"));

var _Typography = _interopRequireDefault(require("../../Typography"));

var _i18n = require("../../constants/i18n");

var _SecureAndPrivate = _interopRequireDefault(require("./SecureAndPrivate"));

var _GiactLink = _interopRequireDefault(require("./GiactLink"));

/** An organism representing methods for linking bank accounts via Giact and Plaid */
var BankLink = function BankLink(_ref) {
  var dataQa = _ref.dataQa,
      _ref$bankLinkRef = _ref.bankLinkRef,
      bankLinkRef = _ref$bankLinkRef === void 0 ? {} : _ref$bankLinkRef,
      bankLinkClassName = _ref.bankLinkClassName,
      btnContainerClassName = _ref.btnContainerClassName,
      plaidComponent = _ref.plaidComponent,
      giactOnSubmit = _ref.giactOnSubmit,
      giactLoading = _ref.giactLoading,
      giactAlertErrorMessage = _ref.giactAlertErrorMessage,
      _ref$giactButtonLabel = _ref.giactButtonLabel,
      giactButtonLabel = _ref$giactButtonLabel === void 0 ? _i18n.BANK_LINK.manuallyEnterBank : _ref$giactButtonLabel,
      _ref$bankAccountTypeK = _ref.bankAccountTypeKey,
      bankAccountTypeKey = _ref$bankAccountTypeK === void 0 ? 'bankAccountType' : _ref$bankAccountTypeK,
      _ref$bankRoutingNumbe = _ref.bankRoutingNumberKey,
      bankRoutingNumberKey = _ref$bankRoutingNumbe === void 0 ? 'bankRoutingNumber' : _ref$bankRoutingNumbe,
      _ref$bankAccountNumbe = _ref.bankAccountNumberKey,
      bankAccountNumberKey = _ref$bankAccountNumbe === void 0 ? 'bankAccountNumber' : _ref$bankAccountNumbe,
      _ref$confirmAccountNu = _ref.confirmAccountNumberKey,
      confirmAccountNumberKey = _ref$confirmAccountNu === void 0 ? 'confirmAccountNumber' : _ref$confirmAccountNu,
      _ref$showSecureAndPri = _ref.showSecureAndPrivate,
      showSecureAndPrivate = _ref$showSecureAndPri === void 0 ? true : _ref$showSecureAndPri;

  var _useState = (0, _react2.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      showGiact = _useState2[0],
      setShowGiact = _useState2[1];
  /**
   * prevent performing state update on unmounted component
   * i.e. form submit may navigate away from this component
   * but setState may still be called by asynchronous business logic
   * that attempts to update local state of unmounted component
   */


  var updateState = function updateState() {
    return setShowGiact(function (prev) {
      return !prev;
    });
  };

  var cbIfMounted = function cbIfMounted(cb) {
    if (bankLinkRef.current) {
      cb();
    }
  };

  var handleShowGiact = function handleShowGiact() {
    return cbIfMounted(updateState);
  };

  (0, _react2.useEffect)(function () {
    bankLinkRef.current = true;
    return function () {
      bankLinkRef.current = false;
    };
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-qa": dataQa,
    className: bankLinkClassName
  }, /*#__PURE__*/_react["default"].createElement(_Gate["default"], {
    condition: Boolean(showSecureAndPrivate)
  }, /*#__PURE__*/_react["default"].createElement(_SecureAndPrivate["default"], null)), /*#__PURE__*/_react["default"].createElement(_Spacing["default"], {
    marginTop: 5
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    justify: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    item: true,
    direction: "column",
    wrap: "nowrap",
    alignItems: "stretch",
    spacing: plaidComponent ? 2 : 0,
    className: btnContainerClassName
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12
  }, plaidComponent), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    dataQa: "giact-btn",
    variant: plaidComponent ? 'text' : 'contained',
    onClick: handleShowGiact,
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    dataQa: "giact-btn-label",
    variant: "overline"
  }, giactButtonLabel)))))), /*#__PURE__*/_react["default"].createElement(_GiactLink["default"], {
    open: showGiact,
    onClose: handleShowGiact,
    onSubmit: giactOnSubmit,
    loading: giactLoading,
    alertErrorMessage: giactAlertErrorMessage,
    bankAccountTypeKey: bankAccountTypeKey,
    bankRoutingNumberKey: bankRoutingNumberKey,
    bankAccountNumberKey: bankAccountNumberKey,
    confirmAccountNumberKey: confirmAccountNumberKey
  }));
};

BankLink.propTypes = {
  /** Selector for QA */
  dataQa: _propTypes["default"].string,

  /** Ref object */
  bankLinkRef: _propTypes["default"].object,

  /** Style applied to the root element */
  bankLinkClassName: _propTypes["default"].string,

  /** Style applied to the button container element */
  btnContainerClassName: _propTypes["default"].string,

  /** Required PlaidLink component */
  plaidComponent: _propTypes["default"].element.isRequired,

  /** The callback fired when the Giact form submit button is clicked */
  giactOnSubmit: _propTypes["default"].func.isRequired,

  /** If `true`, the Giact form submit button may not be clicked */
  giactLoading: _propTypes["default"].bool,

  /** Alert message displayed if error with Giact form submission */
  giactAlertErrorMessage: _propTypes["default"].string,

  /** Giact button label */
  giactButtonLabel: _propTypes["default"].string,

  /** Field name for Giact form field: bank account type */
  bankAccountTypeKey: _propTypes["default"].string,

  /** Field name for Giact form field: bank routing number */
  bankRoutingNumberKey: _propTypes["default"].string,

  /** Field name for Giact form field: bank account number */
  bankAccountNumberKey: _propTypes["default"].string,

  /** Field name for Giact form field: confirm bank account number */
  confirmAccountNumberKey: _propTypes["default"].string
};
var _default = BankLink;
exports["default"] = _default;